// extracted by mini-css-extract-plugin
export default {"duration":"mediaItemLive_duration__0hZKQ","controls":"mediaItemLive_controls__DsuIZ"};